import { motion } from "framer-motion";
import { AlertTriangle, Compass, SearchCheck, HeartHandshake, Siren, ShieldAlert, Radio } from "lucide-react";
import { SITUATIONS } from "@/data/situations";

const ICONS = { AlertTriangle, Compass, SearchCheck, HeartHandshake, Siren, ShieldAlert, Radio };

const TONE = {
  red: { color: "var(--lg-red)", ring: "tac-glow-red", badge: "CRITICAL" },
  cyan: { color: "var(--lg-cyan)", ring: "tac-glow-cyan", badge: "GUIDANCE" },
  lime: { color: "var(--lg-lime)", ring: "tac-glow-lime", badge: "HELP OTHERS" },
  amber: { color: "var(--lg-amber)", ring: "tac-glow-cyan", badge: "CAUTION" },
};

export function SituationCards({ onPick }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {SITUATIONS.map((s, i) => {
        const Icon = ICONS[s.icon] || AlertTriangle;
        const t = TONE[s.tone] || TONE.cyan;
        return (
          <motion.button
            key={s.id}
            type="button"
            onClick={() => onPick(s.id)}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * i, duration: 0.4, ease: "easeOut" }}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.985 }}
            data-testid={`situation-card-${s.id}`}
            className="group glass relative text-left p-5 sm:p-6 rounded-md overflow-hidden min-h-[168px] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--lg-lime)]"
          >
            <div className="absolute inset-0 tac-grid-fine opacity-40 pointer-events-none" />
            <div className="relative flex items-start justify-between">
              <div
                className="h-11 w-11 rounded-md flex items-center justify-center border"
                style={{ borderColor: t.color, color: t.color, boxShadow: `0 0 24px ${t.color}22` }}
              >
                <Icon size={22} />
              </div>
              <span className="font-mono-tac text-[9px] tracking-[0.2em]" style={{ color: t.color }}>
                {t.badge}
              </span>
            </div>
            <div className="relative mt-6">
              <div className="font-display text-2xl sm:text-[26px] font-extrabold uppercase leading-none">
                {s.label}
              </div>
              <div className="mt-2 text-sm text-[color:var(--lg-text-2)]">{s.subtitle}</div>
            </div>
            <div className="relative mt-5 flex items-center gap-2 font-mono-tac text-[10px] tracking-[0.24em] text-[color:var(--lg-text-3)] group-hover:text-[color:var(--lg-lime)] transition-colors">
              <span>ENTER INSTANT MODE</span>
              <span className="inline-block h-px w-8 bg-current" />
            </div>
          </motion.button>
        );
      })}
    </div>
  );
}
